/**
 * ICONIC: eigene Server-Rollen (z. B. «Moderator») mit Fähigkeiten in Klartext.
 * Jede Fähigkeit setzt Rechte an der Server-Gruppe, immer mit «skip», damit Kanal-Rollen sie nicht überschreiben.
 * Stärke 50: wirkt auf Normale (brauchen 50) und Gäste (25), nie auf Server Admins (75) oder SuperAdmin.
 */
export const CAPABILITIES = [
  {
    key: "kickChannel",
    label: "Leute aus Kanälen werfen",
    perms: [["i_client_kick_from_channel_power", 50]],
  },
  {
    key: "move",
    label: "Leute verschieben",
    perms: [["i_client_move_power", 50]],
  },
  {
    key: "kickServer",
    label: "Leute vom Server werfen",
    perms: [["i_client_kick_from_server_power", 50]],
  },
  {
    key: "ban",
    label: "Leute bannen (höchstens 1 Tag)",
    perms: [
      ["b_client_ban_create", 1],
      ["i_client_ban_power", 50],
      ["i_client_ban_max_bantime", 86400],
    ],
  },
  {
    key: "banList",
    label: "Bann-Liste sehen und Banns aufheben",
    perms: [
      ["b_client_ban_list", 1],
      ["b_client_ban_delete", 1],
    ],
  },
  {
    key: "channelRoles",
    label: "In allen Kanälen Kanal-Verwalter, Helfer und Sprecher ernennen",
    perms: [
      ["i_group_member_add_power", 50],
      ["i_group_member_remove_power", 50],
    ],
  },
  {
    key: "channels",
    label: "Kanäle anlegen und ändern (überall)",
    perms: [
      ["b_channel_create_permanent", 1],
      ["b_channel_create_semi_permanent", 1],
      ["b_channel_create_child", 1],
      ["b_channel_modify_name", 1],
      ["b_channel_modify_topic", 1],
      ["b_channel_modify_description", 1],
      ["b_channel_modify_password", 1],
      ["b_channel_modify_maxclients", 1],
      ["b_channel_modify_needed_talk_power", 1],
      ["b_channel_modify_sortorder", 1],
      ["i_channel_modify_power", 75],
    ],
  },
  {
    key: "talk",
    label: "Überall sprechen, auch wo ein Sprechrecht nötig ist",
    perms: [["i_client_talk_power", 75]],
  },
  {
    key: "protect",
    label: "Geschützt vor anderen mit dieser Stärke (nicht rauswerfen, verschieben, bannen)",
    perms: [
      ["i_client_needed_kick_from_channel_power", 60],
      ["i_client_needed_kick_from_server_power", 60],
      ["i_client_needed_move_power", 60],
      ["i_client_needed_ban_power", 60],
    ],
  },
];

/** Werte, die jede eigene Rolle bekommt: vergeben/entziehen/ändern nur durch Server Admins und die Oberfläche */
export const ROLE_BASE_PERMS = [
  ["i_group_needed_member_add_power", 75],
  ["i_group_needed_member_remove_power", 75],
  ["i_group_needed_modify_power", 75],
];

/** Welche Fähigkeiten eine Gruppe hat (alle Rechte der Fähigkeit vorhanden und > 0) */
export function capabilitiesOf(perms) {
  const map = {};
  perms.forEach((p) => (map[p.permsid] = Number(p.permvalue)));
  const out = {};
  CAPABILITIES.forEach((cap) => {
    out[cap.key] = cap.perms.every(([permsid]) => map[permsid] > 0);
  });
  return out;
}

/** Kurze Beschreibung der eingebauten Rollen */
export const BUILTIN_TEXT = {
  admin: "Darf fast alles. Kann SuperAdmin nicht anfassen.",
  normal: "Eigene Kanäle anlegen, Dateien, anstupsen, private Nachrichten. Keine Macht über andere.",
  guest: "Darf rein. Wer neu kommt, ist automatisch Gast.",
  "Super Admin": "Nur SuperAdmin. Geschützt, hier nicht änderbar.",
};
